<template>
  <div class="list-content">
    <Header :leftIcon="leftIcon" :rightIcon="rightIcon" />
    <div class="bottom-list">
      <!-- <deviceList :saveList="saveList" /> -->
      <ul class="device-list" v-if="newSaveList.length">
        <li
          v-for="(item, index) in newSaveList"
          :key="item.deviceId.toString()"
        >
          <span>
            <i
              :class="calssFn(item.deviceType, 'icon')"
              :title="calssFn(item.deviceType, 'title')"
            ></i>
            <i
              style="margin-right:5px"
              :class="equiStatusConvert(item.deviceStatus).icon"
              :title="$t(equiStatusConvert(item.deviceStatus).title)"
            ></i>
            <el-tooltip class="item" effect="dark" placement="top-start">
              <span slot="content">
                <span
                  > {{$t('integration.belonging_to')}}：{{ `${item.fullPath + '/' + item.carrierName}` }}</span
                ><br />{{$t('integration.describe')}}：{{ item.deviceDescription }}
              </span>
              <span>{{ item.deviceName }}</span>
            </el-tooltip>
          </span>

          <!-- <span>{{ item.deviceName }}</span> -->
          <span>
            <i
              class="el-icon-tickets"
              :title="$t('integration.details')"
              @click="handleDetail(item)"
            ></i>
            <i
              class="el-icon-circle-close"
              :title="$t('integration.delete')"
              @click="handleDel(item, index)"
            ></i>
          </span>
        </li>
      </ul>

      <div v-else>
        <el-empty
          :description="
            $t('integration.please_select_the_device_to_analyze_first')
          "
        ></el-empty>
      </div>
    </div>
    <el-button class="loadingMore" @click="saveListFn('')">{{
      $t('integration.save_the_selected_device')
    }}</el-button>
    <setDataDia
      :title="title"
      ref="analSettingDia"
      :isShow.sync="isShow"
      :config="diaConfig"
      :defaultSetting="defaultSetting"
      @save="saveSetting"
      @saveImpl="updateEchart"
    />
  </div>
</template>

<script>
import {
  analItemConvert,
  carrierTypeConvert,
  displayTypeConvert,
  equiStatusConvert,
  gatewayTypeConvert,
  relayTypeConvert
} from '@/utils/convert'
import {
  analyseSaveDeviceList,
  analyseSaveSetting
} from '@/api/modules/dataBoard.js'
import Header from '../components/Header.vue'

// import deviceList from './deviceList.vue';
import setDataDia from '../../dialog/analItem.vue'
import bus from '@/utils/bus'

// 导入Dialog的配置
import sensorConfig from './config/sensorConfig'
import defaultSetting from './config/defaultSetting'
import gatewayConfig from './config/gatewayConfig'
import displayConfig from './config/displayConfig'
import relayConfig from './config/relayConfig'
import { sensorTypeConvert } from '@/utils/dict/sensor'

export default {
  props: {
    saveList: {
      type: Array,
      default: () => []
    },
    deviceIcon: {
      type: String,
      default: '0'
    },
    config: {
      default: () => {
        return {}
      }
    }
  },
  watch: {
    saveList (newVal) {
      this.newSaveList = [...newVal]
    },
    config: {
      handler (newVal) {
        // 因为null===null  会导致切换tab时如果在后端无配置情况下两次值都会为null 因此不会触发更新 因此这里使用Object来代替空数据
        if (typeof newVal === 'string') newVal = JSON.parse(newVal)
        this.$nextTick(() => {
          this.$refs.analSettingDia.setConfig(newVal || {})
        })

        this.leftIcon = []
        let id = 0
        Object.keys({ ...newVal }).forEach(key => {
          this.leftIcon.push({
            id: ++id,
            title: this.$t(analItemConvert(key).title),
            icon: analItemConvert(key).icon
          })
        })
      },
      immediate: true
    },
    deviceIcon: {
      immediate: true,
      handler (newVal) {
        switch (this.deviceIcon) {
          case '0':
          case '5':
          case '6':
            this.diaConfig = { ...sensorConfig }
            break
          case '1':
            this.diaConfig = { ...gatewayConfig }
            break
          case '2':
            this.diaConfig = { ...displayConfig }
            break
          case '3':
            this.diaConfig = { ...relayConfig }
            break
          default:
            break
        }
      }
    }
  },
  components: {
    Header,
    // deviceList,
    setDataDia
  },
  data () {
    return {
      sensorTypeConvert,
      gatewayTypeConvert,
      displayTypeConvert,
      relayTypeConvert,
      diaConfig: null,
      defaultSetting,
      carrierTypeConvert,
      equiStatusConvert,
      leftIcon: [
        {
          id: 1,
          title: $t('integration.zbp_thermometer'),
          icon: 'iconfont icon-wenduji'
        }
      ],
      rightIcon: [
        {
          id: 1,
          title: $t('integration.data_analysis_settings'),
          icon: 'el-icon-setting',
          click () {
            this.isShow = true
            this.title = $t('integration.data_analysis_settings')
          }
        },
        {
          id: 2,
          title: $t('integration.data_board'),
          icon: 'iconfont icon-shujukanban',
          click () {
            bus.$emit('refreshChart')
          }
        }
      ],
      newSaveList: [],
      // 设置数据
      isShow: false,
      title: '',
      deviceName: ''
    }
  },
  methods: {
    calssFn (type, str) {
      switch (this.deviceIcon) {
        // sensorTypeConvert,gatewayTypeConvert,displayTypeConvert,relayTypeConvert
        case '0': {
          return sensorTypeConvert(type)[str]
        }
        case '1': {
          return gatewayTypeConvert(type)[str]
        }
        case '2': {
          return displayTypeConvert(type) && displayTypeConvert(type)[str]
        }
        case '3': {
          return relayTypeConvert(type)[str]
        }
        default:
          break
      }
    },
    handleDetail (row) {
      switch (this.deviceIcon) {
        case '0': {
          bus.$emit('sensorParam', row.deviceId, row.deviceName)
          break
        }
        case '1': {
          bus.$emit('gatewayParam', row.deviceId, row.deviceName)
          break
        }
        case '2': {
          bus.$emit('displayParam', row.deviceId, row.deviceName)
          break
        }
        case '3': {
          bus.$emit('relayParam', row.deviceId, row.deviceName)
          break
        }
        case '5': {
          bus.$emit('gasParam', row.deviceId, row.deviceName)
          break
        }
        case '6': {
          bus.$emit('magnetismParam', row.deviceId, row.deviceName)
          break
        }
        default:
          break
      }
    },
    handleDel (item, index) {
      this.newSaveList.splice(index, 1)
      this.$parent.saveList.splice(index, 1)
      // this.saveListFn($t('integration.successfully_deleted'));
      // 取消列表勾选
      bus.$emit('cancelCheck', item.deviceId)
    },
    handleClick (item) {
      if (item.id === 1) {
        this.isShow = true
        this.title = $t('integration.data_analysis_settings')
        this.deviceName =
          this.deviceIcon === '0'
            ? 'sensor'
            : this.deviceIcon === '1'
              ? 'gateway'
              : this.deviceIcon === '2'
                ? 'display'
                : 'relay'
      } else {
        this.$emit('refreshEchart', this.newSaveList)
      }
    },
    saveSetting (obj) {
      analyseSaveSetting({
        deviceCatalog: this.deviceIcon,
        ...obj
      }).then(async res => {
        if (res.result) {
          this.isShow = false
          await this.$resultHandle(res.state)

          this.refreshIcon(obj)
        }
      })
    },
    updateEchart (obj) {
      this.$emit('clearEchart')
      // 保存并更新Echart
      this.saveSetting(obj)

      // this.$emit('updateEchart', { childrenList: this.newSaveList, obj });
      bus.$emit('refreshChart', obj)
      bus.$emit('refreshLocal', obj)

      this.refreshIcon(obj)
    },
    refreshIcon (config) {
      // 设置上面的分析项图标
      this.leftIcon = []
      let id = 0
      Object.keys({ ...config }).forEach(key => {
        this.leftIcon.push({
          id: ++id,
          title: this.$t(analItemConvert(key).title),
          icon: analItemConvert(key) && analItemConvert(key).icon
        })
      })
    },
    saveListFn (msg) {
      const devIdList = this.newSaveList.map(item => item.deviceId).join(',')
      analyseSaveDeviceList({
        deviceCatalog: this.deviceIcon,
        deviceId: devIdList
      }).then(result => {
        if (result) {
          bus.$emit('saveEchart')
          bus.$emit('refreshChart', this.config, devIdList)
          this.$message.success(msg || $t('integration.saved_successfully'))
          // this.$emit('updateEchart', { id, childrenList: this.newSaveList })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list-content {
  width: 250px;
  height: 100%;
  border: 1px solid #cccccc;
  border-left: 0;
  box-sizing: border-box;
  position: relative;

  .bottom-list {
    height: calc(100% - 80px);
    width: 100%;

    .device-list {
      height: 100%;
      width: 100%;
      padding: 1px;
      box-sizing: border-box;
      overflow: auto;

      li {
        height: 30px;
        border: 1px solid #cccccc;
        margin-bottom: 2px;
        padding: 0 4px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;

        i {
          margin-left: 4px;
          cursor: pointer;
        }
      }
    }
  }

  .loadingMore {
    margin: 5px 0;
    position: absolute;
    left: 2px;
    right: 2px;
    bottom: 0;
  }
}
</style>
